export const mathTypes = {
  visual: {
    id: "visual",
    title: "Visualisierer",
    label: "Graphen & Skizzen",
    description: "Du denkst in Bildern. Ein Koordinatensystem sagt dir mehr als tausend Zeilen Text.",
    contractMethod: "Skizzieren & Graph-Analyse",
    contractWork: "Visualisierung vor Rechnung"
  },
  calculating: {
    id: "calculating",
    title: "Rechner",
    label: "Beispiele & Routinen",
    description: "Du brauchst das Tun. Durch konkrete Beispiele und Wiederholung meisterst du die Abstraktion.",
    contractMethod: "Iterative Rechenbeispiele",
    contractWork: "Routine-Training & Transfer"
  },
  explaining: {
    id: "explaining",
    title: "Erklärer",
    label: "Modelle & Logik",
    description: "Du willst verstehen, warum es funktioniert. Definitionen und Beweise geben dir Sicherheit.",
    contractMethod: "Abstrakte Modellierung",
    contractWork: "Logik-Check & Beweisführung"
  }
};